<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link :to="`/layout/high-light?page=${page}`">精彩瞬间</router-link></li>
                <li class="currentNode"><a>精彩瞬间详情</a></li>
            </ul>
            <div class="page-main">
                <h3>{{ detailTitle }}</h3>
                <ul class="highLight-ul">
                    <li class="highLight-item" v-for="image in imageList" :key="image.Id">
                        <!-- <img  :key="image.ImageUrl" :src="image.ImageUrl"  :alt="image.Title">
                        <span style='padding: 0px 15px'>{{image.Title}}</span> -->
                        <el-image 
                            :src="image.ImageUrl" 
                            :preview-src-list="image.ImageUrlList"
                            :initial-index = "image.initialIndex"
                            @click="clickImage(image.Title, image.initialIndex)">
                        </el-image>
                        <!-- <img :src="image.ImageUrl"/> -->
                        <el-tooltip :content="image.Title" placement="top">
                            <p class="ellipsis_one">{{ image.Title }}</p> 
                        </el-tooltip>
                    </li>
                </ul>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getJingcaiDetail
} from '@services/indexService.js'
import Viewer from 'v-viewer';
   
    import "viewerjs/dist/viewer.css";
export default {
    name:"",
    data() {
        return {
            detailId: '',
            page: '',
            imageList: [],
            detailTitle: '',
            lastMovedIndex: 1,
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.detailTitle = this.$route.query.title;
        this.page = this.$route.query.page;
        this.getJingcaiDetail(this.detailId);
    },
    methods: {
        getJingcaiDetail(id) {
            let params = {
                id: id
            };
            getJingcaiDetail(params).then(res => {
                console.log(res);
                if (res.Code === 1 && res.Data !== null && res.Data.length!==0) {
                    this.imageList = res.Data;
                    let previewSrcList = [];
                    this.imageList.forEach(item => {
                        previewSrcList.push(item.ImageUrl);
                    })
                    this.imageList.map((item, index) => {
                        item.ImageUrlList = previewSrcList;
                        item.initialIndex = index;
                        return item;
                    })
                } else {
                    this.$message.error("精彩瞬间详情请求失败");
                }
            })
        },
        cancelStyle(){
            document.body.style='overflow:auto'; 
        },
        clickImage(title, index) {
            this.cancelStyle();
            let name =title;
            this.srcList2 = this.srcList;
            this.lastMovedIndex = index; // 更新上一次移动的索引
            let _this = this;
            this.$nextTick(async () => {
                let oldDom = document.getElementsByClassName(
                    "el-image-viewer__wrapper"
                )[0];
                let newDom = document.createElement("p");
                newDom.className = 'fix_image_name';
                console.log("name", name);
                let newContent = document.createTextNode(name);
                newDom.appendChild(newContent);
                oldDom.appendChild(newDom);
                let next = document.getElementsByClassName(
                    "el-image-viewer__next"
                )[0];
                let prev = document.getElementsByClassName(
                    "el-image-viewer__prev"
                )[0];
                next.addEventListener("click", function () {
                    let imgDiv = document.getElementsByClassName(
                        "el-image-viewer__canvas"
                    )[0];
                    let imageUrl = imgDiv.getElementsByTagName("img")[0].src;
                    let currentName = _this.imageList.filter(item => item.ImageUrl == imageUrl)[0].Title;
                    let imgTitle = oldDom.getElementsByTagName("p")[0];
                    imgTitle.innerText = currentName;
                });
                prev.addEventListener("click", function () {
                    let imgDiv = document.getElementsByClassName(
                        "el-image-viewer__canvas"
                    )[0];
                    let imageUrl = imgDiv.getElementsByTagName("img")[0].src;
                    let currentName = _this.imageList.filter(item => item.ImageUrl == imageUrl)[0].Title;
                    let imgTitle = oldDom.getElementsByTagName("p")[0];
                    imgTitle.innerText = currentName;
                });
            });
    
        },

    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.highLight-ul{
    padding-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.highLight-item{
    margin-bottom: 20px;
    width: 290px;
    height: 247px;
    background: #116EBA;
    padding:16px;
    box-sizing: border-box;

}
.highLight-ul .highLight-item:nth-child(4n) {
    margin-right:0;
}
.highLight-item image{
    width: 258px;
    height: 164px;
}
.highLight-item p {
    color: #fff;
    font-size: 16px;
    padding: 10px 0;
    text-align:center
}
.highLight-item .el-image {
    width: 258px;
}
</style>
<style>
.fix_image_name{
    position: absolute;
    top: 0px;
    left:0;
    right:0;
    font-size: 20px;
    text-align: center;
    background: #116EBA;
    color: #ffffff;
    padding: 8px;
}
</style>